var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CCol',{attrs:{"md":"12","lg":"12"}},[_c('CCard',[_c('CCardBody',[_c('CRow',[_c('CCol',{attrs:{"sm":"12","lg":"12"}},[_c('a',{attrs:{"href":"/login"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/img/auth.png","alt":""}})])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }